import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42c98aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "horizontal" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "horizontal_empty_content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "horizontal_component"
}
const _hoisted_7 = {
  key: 0,
  class: "horizontal_empty_tip"
}

import draggable from 'vuedraggable';
import { withDefaults, ref, defineAsyncComponent, watch } from 'vue';
import emitter from '@/utils/mitt';
import CDelModal from '@/components/CDelModal.vue';
import { dragDrop } from '@/utils/format/dragDrop';

interface Props {
  component: any;
  Index: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Horizontal',
  props: {
    component: { default: Object },
    Index: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { component: any, Index: any };

const MyLive = defineAsyncComponent(() => import('./MyLive.vue'));
const MyArticle = defineAsyncComponent(() => import('./MyArticle.vue'));
const MyImages = defineAsyncComponent(() => import('./MyImages.vue'));
const Living = defineAsyncComponent(() => import('./Living.vue'));



// tab切换
const clickId = ref(0);

const getTabs = (index: number) => {
  clickId.value = index;
};

// 拖入模块
const horizontal = ref({ ...props.component });
clickId.value = horizontal.value.tabsListClick;
const addModule = (e: any) => {
  let nestedList = [...horizontal.value.tabsList[clickId.value].nestedList];
  if (nestedList.length > 1) {
    nestedList = nestedList.filter((res: any) => {
      const judge = res.type == 2 || res.type == 3 || res.type == 4 || res.type == 5;
      return judge;
    });
    nestedList.length == 2 ? nestedList.splice(e.newIndex, 1) : '';
    nestedList.length == 0 ? (nestedList = [{ id: 0 }]) : '';
    horizontal.value.tabsList[clickId.value].nestedList = nestedList;
  }
};

// 监听标签添加删除
let length = horizontal.value.tabsList.length;
watch(props, () => {
  const id = clickId.value;
  clickId.value = props.component.tabsListClick;
  if (horizontal.value.tabsList.length >= length) {
    length = props.component.tabsList.length;
    clickId.value = id;
  }
});

const getCustom = (item: any) => {
  setTimeout(() => {
    const data = {
      type: item.type,
      index: clickId.value,
      item: props.component,
    };
    emitter.emit('custom', data);
  }, 100);
};

// 重排模块
const resetModule = () => {
  emitter.emit('resetModule', true);
};

// 删除模块
const deleteModal = ref(false);
const deteleData = ref();
const deleteList = (element: any) => {
  deteleData.value = element;
  deleteModal.value = true;
};
const closeModal = () => {
  deleteModal.value = false;
};
const deteleSelect = () => {
  emitter.emit('modalIndex', props.Index);
  horizontal.value.tabsList[clickId.value].nestedList = [{ id: 0 }];
  deleteModal.value = false;
  // emitter.emit('visualization');
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle({ background: props.component.style == 2 ? props.component.senior.defaultLabelColor : '#fff' })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["horizontal_tabs", props.component.style == 2 ? 'horizontal_tabs_two' : ''])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.tabsList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "tabs_every",
            key: index,
            onClick: ($event: any) => (getTabs(index))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["tabs_every_one", [
              clickId.value == index ? 'tabs_every_one_click' : '',
              props.component.style == 1 && clickId.value == index ? 'tabs_every_two_click' : '',
              props.component.style == 2 ? 'tabs_every_three' : '',
              props.component.style == 2 && clickId.value == index ? 'tabs_every_three_click' : '',
              props.component.style == 3 ? 'tabs_every_four' : '',
              props.component.style == 3 && clickId.value == index ? 'tabs_every_four_click' : '',
            ]]),
              style: _normalizeStyle({
              background:
                (props.component.style == 2 || props.component.style == 3) && clickId.value == index
                  ? props.component.senior.selectLabelColor
                  : '',
              '--defaultTextColor': props.component.senior.defaultTextColor,
              '--selecttTextColor': props.component.senior.selecttTextColor,
            })
            }, [
              _createTextVNode(_toDisplayString(item.title) + " ", 1),
              (props.component.style == 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle({ background: props.component.senior.selectLabelColor }),
                    class: "tabs_every_line"
                  }, null, 4))
                : _createCommentVNode("", true)
            ], 6)
          ], 8, _hoisted_2))
        }), 128))
      ], 2)
    ], 4),
    _createElementVNode("div", {
      class: _normalizeClass(props.component.tabsList[clickId.value].nestedList[0].name ? '' : 'horizontal_empty')
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(draggable), {
          class: _normalizeClass(props.component.tabsList[clickId.value].nestedList[0].name ? '' : 'horizontal_empty_draggable'),
          list: props.component.tabsList[clickId.value].nestedList,
          group: { name: 'subassembly' },
          "item-key": "id",
          onAdd: addModule,
          onDrop: _unref(dragDrop)
        }, {
          item: _withCtx(({ element }) => [
            _createElementVNode("div", {
              onClick: ($event: any) => (getCustom(element))
            }, [
              (!element)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true),
              (element && props.component.tabsList[clickId.value].nestedList[0].name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (element.type == 2)
                      ? (_openBlock(), _createBlock(_unref(Living), {
                          key: 0,
                          component: element
                        }, null, 8, ["component"]))
                      : (element.type == 3)
                        ? (_openBlock(), _createBlock(_unref(MyArticle), {
                            key: 1,
                            component: element
                          }, null, 8, ["component"]))
                        : (element.type == 4)
                          ? (_openBlock(), _createBlock(_unref(MyImages), {
                              key: 2,
                              component: element
                            }, null, 8, ["component"]))
                          : (element.type == 5)
                            ? (_openBlock(), _createBlock(_unref(MyLive), {
                                key: 3,
                                component: element
                              }, null, 8, ["component"]))
                            : _createCommentVNode("", true),
                    _createVNode(_component_svg_icon, {
                      class: "component_svg",
                      onClick: _withModifiers(($event: any) => (deleteList(element)), ["stop"]),
                      "icon-class": "delete_circular_click"
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_4)
          ]),
          _: 1
        }, 8, ["class", "list", "onDrop"]),
        (!props.component.tabsList[clickId.value].nestedList[0].name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "请将模块拖入标签区域"))
          : _createCommentVNode("", true),
        (!props.component.tabsList[clickId.value].nestedList[0].name)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              onClick: _withModifiers(resetModule, ["stop"]),
              type: "primary",
              class: "horizontal_empty_btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加模块")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createVNode(CDelModal, {
      visible: deleteModal.value,
      centered: "",
      close: closeModal,
      ok: deteleSelect
    }, null, 8, ["visible"])
  ]))
}
}

})